<div class="credit-card-container" [formGroup]="form">
  <div class="credit-card" [class.flipped]="isFlipped" [attr.data-brand]="getCardBrandClass()">
    <!-- Frente -->
    <div class="card-front">
      <div class="card-header">
        <div class="card-brand">
          <span class="brand-icon">{{ getCardBrandIcon() }}</span>
          <span class="brand-name">{{ cardBrand }}</span>
        </div>
        <div class="card-chip"><div class="chip"></div></div>
      </div>

      <div class="card-number">
        <span class="number">{{ formattedCardNumber }}</span>
      </div>

      <div class="card-footer">
        <div class="card-holder">
          <div class="label">TITULAR</div>
          <div class="value">{{ form.value.cardHolder || "NOME COMPLETO" }}</div>
        </div>
        <div class="card-expiry">
          <div class="label">EXPIRA</div>
          <div class="value">{{ formattedExpiry }}</div>
        </div>
      </div>
    </div>

    <!-- Verso -->
    <div class="card-back">
      <div class="card-stripe"></div>
      <div class="card-signature">
        <div class="signature-strip">
          <div class="cvv-field" role="button" tabindex="0" (click)="onCvvClick()" (keyup.enter)="onCvvClick()">
            <div class="cvv-label">CVV</div>
            <div class="cvv-value">
              @if (showCvvField) {
                <input
                  type="text"
                  formControlName="cvv"
                  (focus)="onCvvFocus()"
                  maxlength="4"
                  placeholder="***"
                  class="cvv-input"
                  [readonly]="readonly" />
              } @else {
                @if (!showCvvField) {
                  <span>{{ form.value.cvv || "***" }}</span>
                }
              }
            </div>
          </div>
        </div>
      </div>
      <div class="card-brand-back">
        <span class="brand-icon">{{ getCardBrandIcon() }}</span>
        <span class="brand-name">{{ cardBrand }}</span>
      </div>
    </div>
  </div>

  <!-- Inputs (edição) -->
  @if (!readonly) {
    <div class="card-inputs">
      <div class="card-input-field">
        <label class="form-label" for="cardNumber">Número do Cartão</label>
        <input
          id="cardNumber"
          type="text"
          inputmode="numeric"
          class="form-control"
          formControlName="cardNumber"
          mask="0000 0000 0000 0000"
          [validation]="false"
          [class.is-invalid]="isFieldInvalid('cardNumber')"
          (focus)="isFlipped && (isFlipped = false)"
          placeholder="1234 5678 9012 3456" />
        @if (isFieldInvalid("cardNumber")) {
          @if (form.get("cardNumber")?.hasError("required")) {
            <small class="text-danger">Informe o número do cartão.</small>
          } @else {
            <small class="text-danger">Número de cartão inválido.</small>
          }
        }
      </div>

      <div class="card-input-field">
        <label class="form-label" for="cardHolder">Nome no Cartão</label>
        <input
          id="cardHolder"
          type="text"
          class="form-control"
          formControlName="cardHolder"
          [class.is-invalid]="isFieldInvalid('cardHolder')"
          (focus)="isFlipped && (isFlipped = false)"
          placeholder="JOÃO SILVA"
          maxlength="26" />
        @if (isFieldInvalid("cardHolder")) {
          <small class="text-danger">Informe o nome no cartão.</small>
        }
      </div>

      <div class="input-row">
        <div class="card-input-field">
          <label class="form-label" for="expiryMonth">Mês</label>
          <input
            id="expiryMonth"
            type="text"
            inputmode="numeric"
            class="form-control"
            formControlName="expiryMonth"
            [class.is-invalid]="isFieldInvalid('expiryMonth')"
            (focus)="isFlipped && (isFlipped = false)"
            placeholder="MM"
            maxlength="2" />
        </div>

        <div class="card-input-field">
          <label class="form-label" for="expiryYear">Ano</label>
          <input
            id="expiryYear"
            type="text"
            inputmode="numeric"
            class="form-control"
            formControlName="expiryYear"
            [class.is-invalid]="isFieldInvalid('expiryYear')"
            (focus)="isFlipped && (isFlipped = false)"
            placeholder="YY"
            maxlength="2" />
        </div>

        <div class="card-input-field">
          <label class="form-label" for="cvv">CVV</label>
          <input
            id="cvv"
            type="text"
            inputmode="numeric"
            class="form-control"
            formControlName="cvv"
            [class.is-invalid]="isFieldInvalid('cvv')"
            (focus)="onCvvFocus()"
            placeholder="***"
            maxlength="4" />
        </div>

        @if (isFieldInvalid("expiryMonth") || isFieldInvalid("expiryYear") || isFieldInvalid("cvv")) {
          <div class="input-errors">
            @if (isFieldInvalid("expiryMonth")) {
              <small class="text-danger">Informe o mês com 2 dígitos (MM).</small>
            }
            @if (isFieldInvalid("expiryYear")) {
              <small class="text-danger">Informe o ano com 2 dígitos (YY).</small>
            }
            @if (isFieldInvalid("cvv")) {
              <small class="text-danger">Informe o CVV (3 ou 4 dígitos).</small>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
